import { defaultIconProps, IconProps } from './IconProps';

export const IconStackConfigure: import('react').FC<IconProps> = ({ size, color, ...rest }) => (
  <svg width={size} height={size} viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
    <path
      d="M1.5 3.66797L11.5 3.66797M11.5 3.66797C11.5 5.04868 12.6193 6.16797 14 6.16797C15.3807 6.16797 16.5 5.04868 16.5 3.66797C16.5 2.28726 15.3807 1.16797 14 1.16797C12.6193 1.16797 11.5 2.28726 11.5 3.66797ZM6.5 10.3346L16.5 10.3346M6.5 10.3346C6.5 11.7153 5.38071 12.8346 4 12.8346C2.61929 12.8346 1.5 11.7153 1.5 10.3346C1.5 8.95392 2.61929 7.83464 4 7.83464C5.38071 7.83464 6.5 8.95392 6.5 10.3346Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

IconStackConfigure.defaultProps = defaultIconProps;
